export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    image: null,
    setting: {
      id: null,
      name: '',
      value: '',
      dataType: '',
    },
  }
}
